'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('ifeis.cash-collect-dialog', ['ngMaterial']).factory('fCashCollectDialog', function ($mdDialog) {
  return function (config, event) {
    return $mdDialog.show({
      event: event,
      controller: function controller($scope, $mdDialog) {
        $scope.cancel = function () {
          $mdDialog.cancel();
        };

        $scope.answer = function (answer, description) {
          if (!answer || !description || answer <= 0 || description.length < 1) {
            return;
          } else {
            $mdDialog.hide([answer, description]);
          }
        };

        $scope.conf = config || {};
      },
      template: require('./tpl.html')
    });
  };
});


//////////////////
// WEBPACK FOOTER
// ./cash-collect-dialog/index.js
// module id = 470
// module chunks = 0